// @flow
import modularui from "../_modularui/ModularUIConnector";

import type { ModularUIConnector } from "../_modularui/types";

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useApplication' instead
 */
export const connectApplication: ModularUIConnector = modularui(
  "Application",
  "/",
  {
    propName: "application",
  },
);
